document.addEventListener('DOMContentLoaded', function () {
  // Select all accordion headings
  const accordionHeadings = document.querySelectorAll('.accordion-block__heading');

  // Loop through each heading and add a click event listener
  accordionHeadings.forEach(function (heading) {
    heading.addEventListener('click', function () {
      // Get the associated content div for the clicked heading
      const content = heading.nextElementSibling;

      // If the content is currently open, close it
      if (content.classList.contains('open')) {
        content.classList.remove('open');
        content.style.maxHeight = null; // Reset height to close it
      } else {
        // Close all other open accordions
        const allContents = document.querySelectorAll('.accordion-block__content');
        allContents.forEach(function (openContent) {
          openContent.classList.remove('open');
          openContent.style.maxHeight = null;
        });

        // Open the clicked accordion
        content.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px'; // Set the height to reveal content
      }
    });
  });
});

var _kl_onSiteForms = _kl_onSiteForms || [];

document.addEventListener("DOMContentLoaded", function() {
  // Grab all buttons with class '.klaviyo-notify-btn'
  var buttons = document.querySelectorAll('.klaviyo-notify-btn');

  // Loop through the buttons and push the form IDs into the _kl_onSiteForms array
  buttons.forEach(function(button) {
    var formId = button.getAttribute('data-form-id');
    
    // Check if the formId is already in the array (to avoid duplicates)
    if (!_kl_onSiteForms.some(function(form) { return form.formId === formId })) {
      _kl_onSiteForms.push({
        formId: formId,
        formType: 'pop-up'
      });
    }
    
    // Add the click event listener to each button
    button.addEventListener('click', function() {
      window._klOnsite.push(['openForm', 'VWRcwb']);
    });
  });
});

// SKU Update functionality
document.addEventListener('DOMContentLoaded', function() {
  // Function to update SKU display
  function updateSkuDisplay(variant) {
    const skuElements = document.querySelectorAll('.product__sku');
    
    skuElements.forEach(function(element) {
      if (variant && variant.sku) {
        // Update the SKU text
        element.innerHTML = '<strong>SKU:</strong> ' + variant.sku;
        element.style.display = 'block';
      } else {
        // Hide SKU if no variant or no SKU
        element.style.display = 'none';
      }
    });
  }

  // Listen for variant change events
  document.addEventListener('theme:variant:change', function(event) {
    const variant = event.detail.variant;
    updateSkuDisplay(variant);
  });

  // Also update on initial page load if variant is already selected
  // This handles cases where the page loads with a variant already selected via URL
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    // Get initial variant from the form data
    const form = productForm.querySelector('form');
    if (form) {
      const formData = new FormData(form);
      const variantId = formData.get('id');
      
      if (variantId && window.productData) {
        const variant = window.productData.variants.find(v => v.id == variantId);
        updateSkuDisplay(variant);
      }
    }
  }
});


// Mobile search: single-tap opens keyboard on iOS Safari and Android Chrome.
// Part 1: open details + focus input synchronously in the click gesture.
// We intercept BEFORE the browser processes default details toggle, manually
// open it, add the is-open class (to make it synchronously visible and focusable),
// focus the input (keyboard opens), and stop event propagation so theme's default handler doesn't close it.
document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-popdown-toggle]');
    if (!toggle) { return; }

    const popdown = toggle.closest('search-popdown');
    const details = toggle.closest('details');
    if (!popdown || !details || details.hasAttribute('open')) { return; }

    const input = popdown.querySelector('input:not([type="hidden"])');
    if (!input) { return; }

    // Intercept click and prevent default theme handler from closing the popdown immediately
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Open details and apply is-open class synchronously so that children are visible/focusable
    details.setAttribute('open', '');
    details.classList.add('is-open');

    // Focus input while still inside the trusted click gesture context to trigger device keyboard
    input.focus();
}, true);

// Part 2: patch trapFocus so the post-animation call targets the input,
// not the container div — prevents iOS from closing the keyboard.
customElements.whenDefined('search-popdown').then(() => {
    const Cls = customElements.get('search-popdown');
    if (!Cls) return;
    const orig = Cls.prototype.popdownTransitionCallback;
    Cls.prototype.popdownTransitionCallback = function (event) {
        const input = this.querySelector('input:not([type="hidden"])');
        if (this.a11y && typeof this.a11y.trapFocus === 'function') {
            const origTrap = this.a11y.trapFocus.bind(this.a11y);
            this.a11y.trapFocus = (opts) => {
                origTrap({ ...opts, elementToFocus: input ?? opts.elementToFocus });
                this.a11y.trapFocus = origTrap;
            };
        }
        orig.call(this, event);
    };
});

// Custom Video mobile script (section.custom-video-mobile.liquid)
document.addEventListener('DOMContentLoaded', function () {

  function updateVideosForScreen() {
    // console.log('>>>>>>>>> updateVideosForScreen >>>', window.innerWidth)
    let isMobile = window.innerWidth <= 767;

    document.querySelectorAll('video[data-mvideo]').forEach(video => {
      let mobileSrc = video.getAttribute('data-mvideo');
      let currentSource = video.querySelector('source');

      if (!mobileSrc) return;

      // 현재 src 저장 (처음 한 번만)
      if (!video.dataset.originalSrc && currentSource) {
        video.dataset.originalSrc = currentSource.getAttribute('src');
      }

      // 모바일일 때
      if (isMobile) {
        if (!currentSource || currentSource.getAttribute('src') !== mobileSrc) {
          video.innerHTML = '';

          let source = document.createElement('source');
          source.src = mobileSrc;
          source.type = 'video/mp4';

          video.appendChild(source);
          video.load();
        }
      } 
      // 데스크탑일 때
      else {
        let originalSrc = video.dataset.originalSrc;

        if (originalSrc && (!currentSource || currentSource.getAttribute('src') !== originalSrc)) {
          video.innerHTML = '';

          let source = document.createElement('source');
          source.src = originalSrc;
          source.type = 'video/mp4';

          video.appendChild(source);
          video.load();
        }
      }
    });
  }

  // 최초 실행
  updateVideosForScreen();

  // resize 대응 (성능 위해 debounce)
  let resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateVideosForScreen, 200);
  });

});